export default __webpack_public_path__ + "static/assets/7fff9e59fa41782073058369932f24ca.svg";